//action that requests get all applications
import {
	CHANGE_APPLICATION_AND_POLICIES_FIELD, FAILED_TO_RECEIVE_LAST_UPDATE_POLICY_FORM, PAGE_SHIFT,
	RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS,
	RECEIVE_GET_ALL_APPLICATIONS, RECEIVE_GET_REQUEST_LAST_UPDATE_POLICY_FORM,
	REQUEST_GET_ALL_APPLICATIONS, REQUEST_GET_LAST_UPDATE_POLICY_FORM,
	RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS_SUGGESTIONS,
	RECEIVE_GET_ALL_APPLICATIONS_SUGGESTIONS,
	REQUEST_GET_ALL_APPLICATIONS_SUGGESTIONS, CLEAR_APPLICATIONS_AND_POLICIES_FILTERS 
} from "./index";
import {actionCreator} from "../helpers/functions";

export const clearApplicationsAndPoliciesFilters = actionCreator(CLEAR_APPLICATIONS_AND_POLICIES_FILTERS);

export function requestGetAllApplications(payload) {
	return {
		type: REQUEST_GET_ALL_APPLICATIONS,
		payload
	}
}

//action that receives all the applications from the api
export function receiveGetAllApplications(applications) {
	return {
		type: RECEIVE_GET_ALL_APPLICATIONS ,
		payload: applications
	}
}

//action that receives bad response fetching all the applications from the api
export function receiveBadResponseGetAllApplications(response) {
	return {
		type: RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS ,
		payload: response
	}
}

export function requestGetAllApplicationsSuggestions(payload) {
	return {
		type: REQUEST_GET_ALL_APPLICATIONS_SUGGESTIONS,
		payload
	}
}

//action that receives all the applications from the api
export function receiveGetAllApplicationsSuggestions(payload) {
	return {
		type: RECEIVE_GET_ALL_APPLICATIONS_SUGGESTIONS ,
		payload
	}
}

//action that receives bad response fetching all the applications from the api
export function receiveBadResponseGetAllApplicationsSuggestions(payload) {
	return {
		type: RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS_SUGGESTIONS ,
		payload
	}
}

//action that changes redux fields
export function changeApplicationsAndPoliciesField(key, value) {
	return {
		type: CHANGE_APPLICATION_AND_POLICIES_FIELD,
		payload: {
			key: key,
			value: value
		}
	}
}

export function requestGetLastUpdatePolicyForm(id) {
	return {
		type: REQUEST_GET_LAST_UPDATE_POLICY_FORM,
		payload: id
	}
}

//action that receives all the applications from the api
export function receiveGetRequestLastUpdatePolicyForm(updatePolicy) {
	return {
		type: RECEIVE_GET_REQUEST_LAST_UPDATE_POLICY_FORM ,
		payload: updatePolicy
	}
}

//action that receives failed response from getting the last update of the policy form
export function failedToReceiveLastUpdatePolicyForm(response) {
	return {
        type: FAILED_TO_RECEIVE_LAST_UPDATE_POLICY_FORM,
		payload: response
	}
}
